import { render, staticRenderFns } from "./PageAccessClassroomRegister.vue?vue&type=template&id=1774f674&scoped=true&"
import script from "./PageAccessClassroomRegister.vue?vue&type=script&lang=js&"
export * from "./PageAccessClassroomRegister.vue?vue&type=script&lang=js&"
import style0 from "./PageAccessClassroomRegister.vue?vue&type=style&index=0&id=1774f674&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1774f674",
  null
  
)

export default component.exports